module.exports = __webpack_public_path__ + "img/barion-banner.259efdf.svg";